import OfferInterface from 'interfaces/offer.interface';

export default function prepare(offers: OfferInterface[]): OfferInterface[] {
    const map = new Map<string, { main: OfferInterface; variants: OfferInterface[]; }>();
    const res: OfferInterface[] = [];

    offers.forEach(offer => {
        if (map.has(offer.dealer.name)) {
            map.get(offer.dealer.name)?.variants.push(offer);
        } else {
            map.set(offer.dealer.name, { main: offer, variants: [] });
        }
    });

    for (const offer of map.values()) {
        res.push({ ...offer.main, variants: offer.variants.sort((a: OfferInterface, b: OfferInterface) => a.price - b.price) });
    }

    return res;
}

export function isMonoOffer(product: { offers: { count: number; }; }): boolean {
    return product.offers.count === 1;
}

export function productHasOffers(product: { offers: { count: number; }; }): boolean {
    return product.offers.count > 0;
}
